import { Radio } from '@heroui/react';
import { LazyImage } from '@ui/common/lazy-image.tsx';

export type PaymentTypeRadioProps = {
  title?: string;
  description?: string;
  image?: string;
  value: string;
};

export const PaymentTypeRadio = ({
  value,
  image,
  title,
  description,
}: PaymentTypeRadioProps) => {
  return (
    <Radio
      classNames={{
        base: 'border rounded-xl px-4 py-3 max-w-none max-h-none m-0',
        labelWrapper: 'w-full',
      }}
      value={value}
    >
      <div className="pl-2 flex flex-row gap-3 w-full">
        <div className="flex flex-col gap-1 flex-grow">
          <p className="text-[#222222] text-sm font-semibold">{title}</p>
          <p className="text-sm text-[#60656C]">{description}</p>
        </div>
        <div className="w-[58px] h-[46px]">
          <LazyImage fit="contain" src={image} />
        </div>
      </div>
    </Radio>
  );
};
